<template>
  <div class="flex flex-wrap complete-menu">
    <!-- flex flex-column-->
    <MenuItem v-for="(item, itemIndex) in items" :key="itemIndex" :icon="item.icon" :text="item.reference" :path-name="item.pathName" :path="item.path" />
  </div>
</template>

<script>
import { computed } from 'vue';
import { useStore } from 'vuex';
import MenuItem from '@/components/menu/MenuItem';

import { menuHandler } from '@/mixins/utils';

export default {
  components: { MenuItem },
  setup () {
    const store = useStore();

    const items = computed(() => {
      const hasSpeedboatContext = !!store.state.user.contexts.find(a => a.value === 'speedboat');
      let menu = menuHandler('Home');

      if (!hasSpeedboatContext) {
        menu = menu.filter(m => m.pathName !== 'Services');
      }

      return menu;
    });

    return { items };
  }
};
</script>

<style>
.complete-menu {
  padding: 0rem 2rem; /*px3*/
}

@media (min-width: 52em) {
  .complete-menu {
    padding: 0rem 0rem;
    margin: 0rem 0rem;
  }
}

</style>
